import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import cx from 'classnames';

export default class LiLink extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  static propTypes = {
    to: PropTypes.string.isRequired
  };

  render() {
    const { router } = this.context;
    const { to, ...rest } = this.props;

    return (
      <li className={cx({ active: router.isActive(to) })}>
        <Link {...rest} to={to}/>
      </li>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/LiLink.jsx